 export default {
  	pagination: {
  		pageNum: 1,
  		pageSize: 10,
  		total: 0,
  		paginationkey: 0
  	},
  	headData: [{
  			title: "文件名",
  			prop: "",
  			width: "100"
  		},
  		{
  			title: "导入总条数",
  			prop: "",
  			width: "120",
  		}, {
  			title: "成功条数",
  			prop: "",
  			width: "170"
  		}, {
  			title: "失败条数",
  			prop: "",
  			width: "170"
  		},
  		{
  			title: "任务状态",
  			prop: "",
  			width: "130"
  		}
  	]
  }
 